import {Navigate} from 'react-router-dom';
import { useUser } from './useUser';

export const PrivateRoute = ({children}) => {
    let user = useUser();
    // console.log(user);
    // console.log(children);

    return user ? children : <Navigate to='/login' />;
}